(function () {
  const scrolledClass = 'tbh-header-scrolled';
  const indexClass = 'tbh-template-index';
  const mainContent = document.querySelector('#MainContent');
  const isIndex = mainContent?.dataset.template?.startsWith('index') === true;

  document.body.classList.toggle(indexClass, isIndex);

  function updateHeaderScrollState() {
    if (!isIndex) {
      document.body.classList.add(scrolledClass);
      return;
    }

    document.body.classList.toggle(scrolledClass, window.scrollY > 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeaderScrollState, { once: true });
  } else {
    updateHeaderScrollState();
  }

  window.addEventListener('scroll', updateHeaderScrollState, { passive: true });
  window.addEventListener('resize', updateHeaderScrollState);
  document.addEventListener('shopify:section:load', updateHeaderScrollState);
})();
